module.exports = __webpack_public_path__ + "static/media/concorde4_optim.54ed423a.jpg";